import React, {
  FormEvent, ChangeEvent, useCallback, useReducer, useState,
} from 'react';
import { Container } from './Container';
import { Button, ButtonModes } from './Button';

const classNames = require('html-classnames');

interface FieldProps {
  name: string,
  type: string,
  label: string,
  value: string,
  onChange: (event: ChangeEvent<HTMLInputElement>) => void,
}

const Field: React.FC<FieldProps> = ({
  name,
  type,
  label,
  value,
  onChange,
}) => {
  const id = `newsletter-${name}`;
  const className = classNames('newsletter__label', {
    '--not-empty': !!value,
  });

  return (
    <label
      htmlFor={id}
      className={className}
    >
      <span>{label}</span>
      <input
        name={name}
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        required
      />
    </label>
  );
};

interface FormState {
  firstName: string,
  lastName: string,
  email: string,
  phone: string,
}

const sendToast = (message: string) => {
  const toast = document.getElementById('toast');
  if (!toast) {
    console.error('Missing toast!');
    return;
  }
  const toastEvent = new CustomEvent('message', { detail: message });
  toast.dispatchEvent(toastEvent);
};

export const Newsletter = () => {
  const [done, setDone] = useState(false);
  const [form, setForm] = useReducer((
    state: FormState,
    { target }: ChangeEvent<HTMLInputElement>,
  ) => ({
    ...state,
    [target.name]: target.value,
  }), {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  });
  const [agreed, setAgreed] = useState(false);

  const handleSubmit = useCallback(async (event: FormEvent) => {
    event.preventDefault();
    if (!agreed) {
      sendToast('😒 chcielibyśmy już to przyjąć ale musisz najpierw zaakceptować regulamin (checkbox niżej)');
      return;
    }
    const post = await fetch('/api/newsletter', {
      method: 'POST',
      body: JSON.stringify(form),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (post.status !== 200) {
      sendToast('🙈 Coś poszło nie tak, spróbuj ponownie');
      return;
    }
    setDone(true);
  }, [form, agreed]);

  return (
    <div className="newsletter">
      <Container>
        {done ? (
          <>
            <h2>Super!</h2>
            <p>Dostaliśmy Twoje dane i na pewno wkrótce otrzymasz od nas pierwszą wiadomość!</p>
          </>
        ) : (
          <>
            <h2>Zostańmy w kontakcie</h2>
            <form action="#" onSubmit={handleSubmit}>
              <Field
                name="firstName"
                type="text"
                label="Twoje imię"
                value={form.firstName}
                onChange={setForm}
              />
              <Field
                name="lastName"
                type="text"
                label="Twoje nazwisko"
                value={form.lastName}
                onChange={setForm}
              />
              <Field
                name="phone"
                type="tel"
                label="Telefon"
                value={form.phone}
                onChange={setForm}
              />
              <Field
                name="email"
                type="email"
                label="Twój e-mail"
                value={form.email}
                onChange={setForm}
              />
              <Button
                mode={ButtonModes.contrast}
                isButton
                type="submit"
              >
                Dołącz do newslettera
              </Button>
              <label
                htmlFor="newsletter-legal"
                className="newsletter__label--legal"
              >
                <input
                  type="checkbox"
                  id="newsletter-legal"
                  checked={agreed}
                  onChange={() => { setAgreed(!agreed); }}
                />
                <span>
                  Chcę co tydzień dostawać newsletter o Razem.
                  {' '}
                  Klikając powyższy guzik, wyrażasz zgodę na
                  {' '}
                  <a
                    href="/polityka-prywatnosci/"
                    target="_blank"
                  >
                    przetwarzanie Twoich podanych wyżej danych
                  </a>
                  {' '}
                  przez Razem w celu obsługi zgłoszenia i nawiązania kontaktu.
                  {' '}
                  Nikomu nie udostępnimy Twoich danych.
                  {' '}
                  W każdym momencie możesz usunąć swoje dane z naszej bazy.
                </span>
              </label>
            </form>
          </>
        ) }
      </Container>
    </div>
  );
};
